import Vue from 'vue'

const dateOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
}

Vue.filter('formatDate', (value, showTime = false, options = {}) => {
  const timestamp = Date.parse(value),
    combinedOptions = Object.assign(dateOptions, options)

  if (!isNaN(timestamp)) {
    const date = new Date(timestamp)

    if (showTime) {
      date.toLocaleTimeString('en-NL', combinedOptions)
    }

    return date.toLocaleDateString('en-NL', combinedOptions)
  }

  return value
})
